import React from 'react';
import { useLanguage } from '../i18n';
import { getProduct, productPilotUrl } from '../products';
import Multiline from './Multiline';
import { CONTACT_EMAIL, CONTACT_PHONE_DISPLAY, CONTACT_PHONE_TEL } from './Footer';

export const CALENDLY_URL = 'https://calendly.com/tamerintech/30min';

/** Contact: book a conversation with Ron, or apply for a ContextFriend pilot. */
const Contact: React.FC = () => {
  const { t, language } = useLanguage();
  const pilotHref = productPilotUrl(getProduct('contextfriend'), language, 'homepage_contact');

  return (
    <section className="lp-contact" id="contact" aria-labelledby="contact-heading">
      <div className="lp-wrap lp-contact-inner">
        <div>
          <h2 id="contact-heading">
            <Multiline text={t.contact.heading} />
          </h2>
        </div>
        <div className="lp-contact-actions">
          <p>
            <Multiline text={t.contact.body} />
          </p>
          <div className="lp-contact-buttons">
            <a className="lp-button" href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
              <span>{t.contact.cta}</span>
              <span aria-hidden="true">↗</span>
            </a>
            {pilotHref && (
              <a
                className="lp-button lp-button--ghost"
                href={pilotHref}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="pilot-cta"
              >
                <span>{t.contact.pilotCta}</span>
                <span aria-hidden="true">↗</span>
              </a>
            )}
          </div>
          <p className="lp-contact-note">
            {t.contact.note} <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> ·{' '}
            <a href={`tel:${CONTACT_PHONE_TEL}`}>{CONTACT_PHONE_DISPLAY}</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
